import React from 'react';

import config from '@config';
import { getAppDownloadLink } from '@helpers';

const AppBanner = () => {
  if (window.innerWidth > config.breakpoints.mobile) {
    return null;
  }

  return (
    <div className="tvg-app-banner">
      <div className="tvg-app-banner__text">
        <h5>Get the Freeview App</h5>
        <a href={getAppDownloadLink()}>
          Download the app <i className="icon-chevron" />
        </a>
      </div>
      <img
        src="/themes/custom/freeview/img/icons/fw_app.svg"
        alt=""
        loading="lazy"
      />
    </div>
  );
};

export default AppBanner;
